import styled from "styled-components";
import cssVars from "../../../../styles/cssVariables.vars";

export const StyledCreateAutomaticMsgRoutinePage = styled.div`
	background-color: ${cssVars.colorGrey[7]};
	padding: 1rem;
	display: flex;
	flex-direction: column;
	border-radius: 0.5rem;

	.select-options {
		display: flex;
		flex-direction: column;

		gap: 1rem;
		width: 100%;
	}

	button {
		background-color: var(--color-primary);
		color: var(--color-grey-2);
		display: flex;
		align-items: center;
		text-decoration: none;
		width: max-content;
		gap: 0.5rem;
		cursor: pointer;

		font-size: 0.875rem;
		font-weight: 500;

		&:disabled {
			background-color: var(--color-primary-dark);
			opacity: 0.7;
			cursor: not-allowed;
		}

		&:hover {
			background-color: var(--color-primary-1);
		}

		@media (max-width: 50rem) {
			width: 100%;
		}
	}
`;
